import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";
import moment from "moment";
import { DatePicker } from "antd";
import { findItemValueByIdFromArray } from "helpers/find-item-by-id-from-array";
import SearchSelect from "views/lib/components/SearchSelect";
import {
  tariffGetList
} from "actions/tariff/actions";

const format = "YYYY-MM-DD";

const ModalTariff1 = (props) => {
  const {
    tariffGetList,
    tariffList,
    onCancel
  } = props;

  const [currentTariffId, setCurrentTariffId] = useState(props.currentTariffId || null);
  const [until, setUntil] = useState(moment()
    .endOf("day")
    .valueOf());

  const handleChange = option => {
    setCurrentTariffId(option ? option.value : null);
  };

  const handleSubmit = () => {
    const tariff = tariffList.find(item => item.id === currentTariffId);
    if (!tariff) return;
    props.onSubmit(tariff, until);
  };

  useEffect(() => {
    tariffGetList();
  }, [tariffGetList]);

  const tariffOptions = tariffList
    .filter(item => item.activable && item.active)
    .map(item => ({
      label: item.code,
      value: item.id
    }));

  const tariffSelected = findItemValueByIdFromArray(
    tariffOptions,
    "value",
    currentTariffId
  ) || null;

  return (
    <div>
      <div className="form-group">
        <label>Tariff</label>
        <SearchSelect
          className="search-select"
          onChange={handleChange}
          options={tariffOptions}
          isSearchable={true}
          isClearable={false}
          value={tariffSelected}
          isLoading={false}
        />
      </div>
      <div className="form-group">
        <label>Active Until</label>
        <DatePicker
          value={moment(until)}
          format={format}
          onChange={(date) => {
            setUntil(moment(date)
              .valueOf());
          }}
          className="d-block"
          placeholder="Not set"
          allowClear={false}
        />
      </div>
      <div className="text-right">
        <button
          className="btn btn-danger mr-2"
          onClick={onCancel}
        >
          Cancel
        </button>
        <button
          className="btn btn-success"
          onClick={handleSubmit}
          disabled={!currentTariffId}
        >
          Save
        </button>
      </div>
    </div>
  );
};

class ModalTariff extends React.Component {
  format = "YYYY-MM-DD";

  constructor(props) {
    super(props);

    this.state = {
      currentTariffId: this.props.currentTariffId || null,
      until: moment()
        .endOf("day")
        .valueOf()
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

    this.props.tariffGetList();
  }

  handleChange = (option) => {
    this.setState({
      currentTariffId: option ? option.value : null
    });
  };

  handleSubmit = () => {
    const { tariffList } = this.props;
    const { until } = this.state;
    const tariff = tariffList.find(item => item.id === this.state.currentTariffId);
    if (!tariff) {
      return;
    }
    this.props.onSubmit(tariff, until);
  };

  render() {
    const {
      tariffList,
    } = this.props;
    const {
      currentTariffId,
      until
    } = this.state;

    const tariffOptions = tariffList.map(item => ({
      label: item.name,
      value: item.id
    }));

    const tariffSelected = findItemValueByIdFromArray(
      tariffOptions,
      "value",
      currentTariffId
    ) || null;

    return (
      <div>
        <div className="form-group">
          <label>Tariff</label>
          <SearchSelect
            className="search-select"
            onChange={this.handleChange}
            options={tariffOptions}
            isSearchable={true}
            isClearable={false}
            value={tariffSelected}
            isLoading={false}
          />
        </div>
        <div className="form-group">
          <label>Active Until</label>
          <DatePicker
            value={moment(until)}
            format={this.format}
            onChange={(date) => {
              this.setState({
                until: moment(date)
                  .valueOf()
              });
            }}
            className="d-block"
            placeholder="Not set"
            allowClear={false}
          />
        </div>
        <div className="text-right">
          <button
            className="btn btn-danger mr-2"
            onClick={this.props.onCancel}
          >
            Cancel
          </button>
          <button
            className="btn btn-success"
            onClick={this.handleSubmit}
            disabled={!currentTariffId}
          >
            Save
          </button>
        </div>
      </div>
    );
  }
}

ModalTariff.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  currentTariffId: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]).isRequired
};

const mapStateToProps = state => ({
  tariffList: state.tariff.tariffList,
});

const mapStateToDispatch = dispatch => ({
  tariffGetList: bindActionCreators(tariffGetList, dispatch)
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(ModalTariff1);



// WEBPACK FOOTER //
// ./src/views/pages/users/modal-tariff.js